export const deepEqual: <T>(a: T, b: T) => boolean = require('deep-equal');



// WEBPACK FOOTER //
// ./src/util/deepEqual.ts